import { createFileRoute } from '@tanstack/react-router'
import { PERMISSION_ROLES } from '../../../src/constants/premissions'
import { accountSearchSchema } from '../../../src/schemas/routeSchemas'
import { requirePermission } from '../../../src/utils/routePermissions'

export const Route = createFileRoute('/account/management')({
  validateSearch: (search) => accountSearchSchema.parse(search),
  loaderDeps: () => ({}),
  beforeLoad: ({ context }) => {
    requirePermission(context, Route.options.staticData?.permissionRequired)
  },
  staticData: {
    permissionRequired: PERMISSION_ROLES.ACCOUNT_MANAGEMENT,
  },
})
